module.exports = __webpack_public_path__ + "src/assets/img/background.5106c434.png";